/* RESPONSIBLE TEAM: team-standalone */
import BaseValidator from 'ember-cp-validations/validators/base';
import { inject as service } from '@ember/service';
import type AppService from 'embercom/services/app-service';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';
import type IntlService from 'ember-intl/services/intl';
import type Store from '@ember-data/store';
import { extractTemplateVariables } from 'embercom/lib/workflows/template-variables';
import {
  getValidatedPlatform,
  isFieldUnavailableInProduction,
} from 'embercom/validators/standalone/field-availability-utils';
import { type BlockList } from '@intercom/interblocks.ts';

interface BlocksFragment {
  toArray(): BlockList;
}

export default class BlockFieldsAvailableInProduction extends BaseValidator {
  @service declare appService: AppService;
  @service declare finStandaloneService: FinStandaloneService;
  @service declare intl: IntlService;
  @service declare store: Store;

  validate(blocks: BlocksFragment | null | undefined, options: { messageKey: string }) {
    if (!blocks) {
      return true;
    }

    let platform = getValidatedPlatform(this.appService, this.finStandaloneService);
    if (!platform) {
      return true;
    }

    let identifiers = extractTemplateVariables(blocks.toArray());

    for (let identifier of identifiers) {
      if (isFieldUnavailableInProduction(identifier, platform, this.store)) {
        return this.intl.t(options.messageKey);
      }
    }

    return true;
  }

  static getDependentsFor() {
    return [];
  }
}
